/* Design system Anasol (weup-an-ds-*): régua de FPS, vídeo do topo, banners, faixas de vídeo e player.
   Portado de mockups/anasol-home/script.js + script-dobras.js (repo Hidrasol). Cada parte só age se a peça
   existir na página; seções repetidas não duplicam nada (marcam data-an-pronto). */
(function () {
  "use strict";
  var menos = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  function cada(sel, f) { document.querySelectorAll(sel).forEach(function (el) { if (el.dataset.anPronto) return; el.dataset.anPronto = "1"; f(el); }); }

  /* ---------- vídeo do topo: pôster primeiro; o vídeo só entra visível, sem "reduzir movimento" e sem economia de dados ---------- */
  cada(".an .topo-video", function (video) {
    var largo = window.matchMedia("(min-width: 768px)").matches;
    if (largo && video.dataset.posterDesktop) video.poster = video.dataset.posterDesktop;
    var economia = navigator.connection && navigator.connection.saveData;
    if (menos || economia || !("IntersectionObserver" in window)) return;
    new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting) { if (!video.paused) video.pause(); return; }
        if (!video.src) video.src = largo ? video.dataset.srcDesktop : video.dataset.srcCelular;
        var p = video.play(); if (p && p.catch) p.catch(function () {});
      });
    }, { threshold: 0.25 }).observe(video);
  });

  /* ---------- a régua de FPS: os produtos já vêm no HTML (Liquid), com data-fps; a régua acende os do FPS escolhido ---------- */
  cada(".an .regua", function (regua) {
    var raiz = regua.closest(".fps");
    var sol = regua.querySelector(".regua-sol");
    var pilula = regua.querySelector(".regua-pilula b");
    var degraus = [].slice.call(regua.querySelectorAll("[data-degrau]"));
    var valores = degraus.map(function (b) { return +b.dataset.degrau; });
    var itens = [].slice.call(raiz.querySelectorAll(".regua-produto"));
    var vitrine = raiz.querySelector(".vitrine");
    var fantasmas = [].slice.call(raiz.querySelectorAll(".fantasma"));
    var atual = +regua.dataset.fps || valores[0];
    var porFps = {};
    itens.forEach(function (li) { (porFps[li.dataset.fps] = porFps[li.dataset.fps] || []).push(li); });

    function posicao(i) { return valores.length > 1 ? i / (valores.length - 1) : 0.5; }
    function posiciona() {
      degraus.forEach(function (b, i) { b.parentNode.style.left = (posicao(i) * 100) + "%"; });
      sol.style.transform = "translateX(" + (posicao(valores.indexOf(atual)) * regua.clientWidth) + "px)";
    }
    function mostra(fps, anima) {
      if (fps === atual && !anima) return;
      atual = fps;
      var lista = porFps[fps] || [];
      regua.dataset.fps = fps;
      regua.setAttribute("aria-valuenow", fps);
      regua.setAttribute("aria-valuetext", "FPS " + fps + ": " + lista.length + (lista.length === 1 ? " protetor" : " protetores"));
      degraus.forEach(function (b) { b.setAttribute("aria-current", +b.dataset.degrau === fps ? "true" : "false"); });
      // nas pontas da régua a setinha daquele lado some (não há para onde arrastar)
      regua.classList.toggle("na-ponta-esq", valores.indexOf(fps) === 0);
      regua.classList.toggle("na-ponta-dir", valores.indexOf(fps) === valores.length - 1);
      if (pilula) pilula.textContent = fps;
      posiciona();
      var k = 0;
      itens.forEach(function (li) {
        var acesa = +li.dataset.fps === fps;
        li.hidden = !acesa;
        li.classList.toggle("acesa", acesa);
        li.classList.remove("entrando");
        if (acesa && anima && !menos) { void li.offsetWidth; li.style.setProperty("--i", k++); li.classList.add("entrando"); }
      });
      if (vitrine) { vitrine.setAttribute("aria-label", "Protetores FPS " + fps); vitrine.scrollLeft = 0; }
      var i = valores.indexOf(fps), viz = [valores[i - 1], valores[i + 1], valores[i + 2]];
      fantasmas.forEach(function (img, n) {
        var f = viz[n], p = f && porFps[f] && porFps[f][0] && porFps[f][0].querySelector("img");
        img.style.opacity = p ? "" : "0";
        if (p) { img.src = p.currentSrc || p.src; img.dataset.fps = f; }
      });
    }
    function maisPerto(x) {
      var r = regua.getBoundingClientRect(), t = Math.min(1, Math.max(0, (x - r.left) / r.width)), melhor = 0, d = 9;
      valores.forEach(function (v, i) { var dd = Math.abs(posicao(i) - t); if (dd < d) { d = dd; melhor = i; } });
      return { i: melhor, t: t };
    }
    var arrastando = false;
    function move(e) {
      if (!arrastando) return;
      var m = maisPerto(e.clientX);
      sol.style.transform = "translateX(" + (m.t * regua.clientWidth) + "px)";
      if (valores[m.i] !== atual) mostra(valores[m.i]);
    }
    function solta(e) {
      if (!arrastando) return;
      arrastando = false; regua.classList.remove("arrastando");
      mostra(valores[maisPerto(e.clientX).i], true);
    }
    sol.addEventListener("pointerdown", function (e) {
      arrastando = true; regua.classList.add("arrastando");
      try { if (e.pointerId != null) sol.setPointerCapture(e.pointerId); } catch (x) {}
      e.preventDefault();
    });
    sol.addEventListener("pointermove", move);
    sol.addEventListener("pointerup", solta);
    sol.addEventListener("pointercancel", solta);
    regua.addEventListener("pointermove", move);
    regua.addEventListener("pointerup", solta);
    regua.querySelector(".regua-trilho").addEventListener("click", function (e) { mostra(valores[maisPerto(e.clientX).i], true); });
    degraus.forEach(function (b) { b.addEventListener("click", function () { mostra(+b.dataset.degrau, true); regua.focus({ preventScroll: true }); }); });
    regua.addEventListener("keydown", function (e) {
      var i = valores.indexOf(atual), n = i;
      if (e.key === "ArrowRight" || e.key === "ArrowUp") n = Math.min(valores.length - 1, i + 1);
      else if (e.key === "ArrowLeft" || e.key === "ArrowDown") n = Math.max(0, i - 1);
      else if (e.key === "Home") n = 0;
      else if (e.key === "End") n = valores.length - 1;
      else return;
      e.preventDefault();
      if (n !== i) mostra(valores[n], true);
    });
    window.addEventListener("resize", posiciona);
    mostra(atual, true);
  });

  /* ---------- arrastar com o mouse as faixas que rolam de lado ---------- */
  cada(".an .banners-faixa, .an .escolhidos-lista, .an .vitrine", function (f) {
    f.setAttribute("data-arrasta", "");
    var x0 = 0, s0 = 0, ativo = false, moveu = false;
    f.addEventListener("pointerdown", function (e) {
      if (e.pointerType !== "mouse" || f.scrollWidth <= f.clientWidth) return;
      ativo = true; moveu = false; x0 = e.clientX; s0 = f.scrollLeft;
    });
    window.addEventListener("pointermove", function (e) {
      if (!ativo) return;
      var dx = e.clientX - x0;
      if (Math.abs(dx) > 4) { moveu = true; f.classList.add("arrastando"); }
      f.scrollLeft = s0 - dx;
    });
    window.addEventListener("pointerup", function () { if (!ativo) return; ativo = false; setTimeout(function () { f.classList.remove("arrastando"); }, 0); });
    f.addEventListener("click", function (e) { if (moveu) { e.preventDefault(); e.stopPropagation(); moveu = false; } }, true);
  });

  /* ---------- banners: pontos e setas ---------- */
  cada(".an .banners", function (sec) {
    var faixa = sec.querySelector(".banners-faixa");
    var banners = [].slice.call(faixa.querySelectorAll(".banner"));
    var pontos = [].slice.call(sec.querySelectorAll(".pontos button"));
    var atual = 0;
    function vai(i) {
      i = (i + banners.length) % banners.length;
      var b = banners[i];
      faixa.scrollTo({ left: b.offsetLeft - (faixa.clientWidth - b.clientWidth) / 2, behavior: menos ? "auto" : "smooth" });
    }
    function marca() {
      var c = faixa.scrollLeft + faixa.clientWidth / 2, melhor = 0, d = 1e9;
      banners.forEach(function (b, i) { var dd = Math.abs(b.offsetLeft + b.clientWidth / 2 - c); if (dd < d) { d = dd; melhor = i; } });
      atual = melhor;
      pontos.forEach(function (p, i) { p.setAttribute("aria-selected", i === melhor ? "true" : "false"); });
    }
    faixa.addEventListener("scroll", function () { window.requestAnimationFrame(marca); }, { passive: true });
    pontos.forEach(function (p, i) { p.addEventListener("click", function () { vai(i); }); });
    var ant = sec.querySelector("[data-ant]"), prox = sec.querySelector("[data-prox]");
    if (ant) ant.addEventListener("click", function () { vai(atual - 1); });
    if (prox) prox.addEventListener("click", function () { vai(atual + 1); });
  });

  /* ---------- a Juliana: as fotos deslizam dentro das molduras, cada vez com outro produto, e o cartão troca junto.
     Quem marca o tempo é o preenchimento do ponto ativo (CSS): pausar é parar a animação dele (mouse em cima, foco
     dentro, fora da tela, aba escondida, filme aberto); com "reduzir movimento" não passa sozinho e a troca só esmaece. ---------- */
  cada(".an .juliana", function (sec) {
    var cartoes = [].slice.call(sec.querySelectorAll(".ju-produto")), pontos = [].slice.call(sec.querySelectorAll(".ju-pontos button"));
    var n = cartoes.length; if (n < 2) return;
    var molduras = [].slice.call(sec.querySelectorAll(".ju-foto")).map(function (f) { return [].slice.call(f.querySelectorAll(".ju-slide")); });
    var atual = 0, mola = "cubic-bezier(.22, 1, .36, 1)", motivos = {};
    function carrega(k) { molduras.forEach(function (f) { if (f[k]) f[k].loading = "eager"; }); }
    function vai(k, dir) {
      k = (k + n) % n; if (k === atual) return;
      dir = dir || (k > atual ? 1 : -1);
      molduras.forEach(function (f, m) {
        var sai = f[atual], entra = f[k]; if (!sai || !entra) return;
        sai.getAnimations().forEach(function (a) { a.finish(); }); entra.getAnimations().forEach(function (a) { a.cancel(); });
        sai.classList.remove("is-ativo"); sai.classList.add("saindo"); sai.setAttribute("aria-hidden", "true");
        entra.classList.remove("saindo"); entra.classList.add("is-ativo"); entra.removeAttribute("aria-hidden");
        var t = { duration: menos ? 320 : 950, delay: menos ? 0 : m * 90, easing: mola };
        var a = sai.animate(menos ? [{ opacity: 1 }, { opacity: 0 }] : [{ transform: "none" }, { transform: "translateX(" + (-dir * 30) + "%)" }], Object.assign({ fill: "forwards" }, t));
        a.onfinish = function () { sai.classList.remove("saindo"); a.cancel(); };
        entra.animate(menos ? [{ opacity: 0 }, { opacity: 1 }] : [{ transform: "translateX(" + (dir * 100) + "%) scale(1.06)" }, { transform: "none" }], Object.assign({ fill: "backwards" }, t));
      });
      cartoes.forEach(function (c, i) {
        var on = i === k; c.classList.toggle("is-ativo", on);
        if (on) { c.removeAttribute("aria-hidden"); c.removeAttribute("tabindex"); } else { c.setAttribute("aria-hidden", "true"); c.tabIndex = -1; }
      });
      pontos.forEach(function (p, i) { p.setAttribute("aria-pressed", i === k ? "true" : "false"); });
      atual = k; carrega((k + 1) % n);
    }
    function pausa(m, sim) { motivos[m] = sim; sec.classList.toggle("pausado", Object.keys(motivos).some(function (x) { return motivos[x]; })); }
    pontos.forEach(function (p, i) { p.addEventListener("click", function () { vai(i); }); });
    var ant = sec.querySelector(".ju-ant"), prox = sec.querySelector(".ju-prox");
    if (ant) ant.addEventListener("click", function () { vai(atual - 1, -1); });
    if (prox) prox.addEventListener("click", function () { vai(atual + 1, 1); });
    // o preenchimento do ponto ativo terminou: próximo
    sec.addEventListener("animationend", function (e) { if (e.target.closest && e.target.closest(".ju-pontos button[aria-pressed='true']")) vai(atual + 1, 1); });
    sec.addEventListener("pointerenter", function (e) { if (e.pointerType === "mouse") pausa("mouse", true); });
    sec.addEventListener("pointerleave", function (e) { if (e.pointerType === "mouse") pausa("mouse", false); });
    sec.addEventListener("focusin", function () { pausa("foco", true); });
    sec.addEventListener("focusout", function (e) { if (!sec.contains(e.relatedTarget)) pausa("foco", false); });
    document.addEventListener("visibilitychange", function () { pausa("aba", document.hidden); });
    if ("IntersectionObserver" in window) new IntersectionObserver(function (es) { es.forEach(function (e) { pausa("fora", !e.isIntersecting); }); }, { threshold: 0.3 }).observe(sec);
    var dlg = document.querySelector(".an-player"); if (dlg) new MutationObserver(function () { pausa("filme", dlg.open); }).observe(dlg, { attributes: true, attributeFilter: ["open"] });
    // arrastar de lado na colagem também troca (no toque e no mouse); o botão do filme fica de fora
    var col = sec.querySelector(".ju-colagem"), x0 = null;
    col.addEventListener("pointerdown", function (e) { x0 = e.target.closest(".ju-play") ? null : e.clientX; });
    col.addEventListener("pointerup", function (e) { if (x0 === null) return; var dx = e.clientX - x0; x0 = null; if (Math.abs(dx) > 40) vai(atual + (dx < 0 ? 1 : -1), dx < 0 ? 1 : -1); });
    carrega(1);
  });

  /* ---------- "O que você quer proteger?": os sóis são abas; tocar abre o painel daquela necessidade (setas do teclado também) ---------- */
  document.querySelectorAll(".an .proteger").forEach(function (sec) {
    if (sec.dataset.anPronto) return; sec.dataset.anPronto = "1";
    var tabs = [].slice.call(sec.querySelectorAll('[role="tab"]'));
    function abre(t, foco) {
      tabs.forEach(function (x) { var on = x === t; x.setAttribute("aria-selected", on ? "true" : "false"); x.tabIndex = on ? 0 : -1;
        var pn = document.getElementById(x.getAttribute("aria-controls")); if (pn) pn.hidden = !on; });
      if (foco) t.focus({ preventScroll: true });
      var faixa = t.parentElement; if (faixa.scrollWidth > faixa.clientWidth) faixa.scrollTo({ left: t.offsetLeft - (faixa.clientWidth - t.offsetWidth) / 2, behavior: "smooth" });
    }
    tabs.forEach(function (t, i) {
      t.addEventListener("click", function () { abre(t, false); });
      t.addEventListener("keydown", function (e) {
        var n = { ArrowRight: i + 1, ArrowLeft: i - 1, Home: 0, End: tabs.length - 1 }[e.key];
        if (n === undefined) return; e.preventDefault(); abre(tabs[(n + tabs.length) % tabs.length], true);
      });
    });
  });

  /* ---------- faixas de vídeo: trilho duplicado para a volta sem emenda; param fora da tela.
     Nenhum vídeo duas vezes na tela: a faixa nunca passa de um conjunto menos um cartão (em tela mais larga, encolhe
     e fica no meio); com "reduzir movimento" a faixa rola parada e não leva cópia. ---------- */
  var lista = [];
  cada(".an .v-trilho", function (t) {
    [].slice.call(t.children).forEach(function (c) {
      lista.push(c.dataset.video);
      if (menos) return;
      var k = c.cloneNode(true); k.setAttribute("aria-hidden", "true"); k.tabIndex = -1; t.appendChild(k);
    });
  });
  function cabe() {
    if (menos) return;
    document.querySelectorAll(".an .v-faixa").forEach(function (f) {
      var t = f.querySelector(".v-trilho"), c = t && t.firstElementChild; if (!c) return;
      var vao = parseFloat(getComputedStyle(t).columnGap) || 0, max = t.offsetWidth / 2 - c.offsetWidth - vao;
      f.style.maxWidth = f.parentElement.clientWidth > max ? Math.floor(max) + "px" : "";
    });
  }
  cabe(); window.addEventListener("resize", cabe);
  if ("IntersectionObserver" in window) {
    cada(".an .v-faixa", function (f) {
      new IntersectionObserver(function (es) { es.forEach(function (e) { f.classList.toggle("parado", !e.isIntersecting); }); }).observe(f);
    });
  }

  /* ---------- player: vídeos mudos em sequência (como na home da Hidrabene) ou o filme com som ---------- */
  var dlg = document.querySelector(".an-player");
  if (!dlg || dlg.dataset.anPronto) return;
  dlg.dataset.anPronto = "1";
  var v = dlg.querySelector("video"), barra = dlg.querySelector(".player-barra i");
  var fila = [], i = 0, filme = false;
  function toca() { v.src = fila[i]; v.currentTime = 0; var p = v.play(); if (p && p.catch) p.catch(function () {}); }
  function abre(f, k, comSom) {
    fila = f; i = k; filme = !!comSom;
    v.muted = !filme; v.controls = filme;
    dlg.classList.toggle("unico", fila.length < 2);
    dlg.classList.toggle("largo", filme);
    document.querySelectorAll(".an .v-faixa").forEach(function (x) { x.classList.add("parado"); });
    dlg.showModal(); toca();
  }
  function fecha() { v.pause(); v.removeAttribute("src"); v.load(); if (dlg.open) dlg.close(); document.querySelectorAll(".an .v-faixa").forEach(function (x) { x.classList.remove("parado"); }); }
  v.addEventListener("timeupdate", function () { if (v.duration) barra.style.width = (100 * v.currentTime / v.duration) + "%"; });
  v.addEventListener("ended", function () { if (filme || fila.length < 2) return fecha(); i = (i + 1) % fila.length; toca(); });
  v.addEventListener("volumechange", function () { if (!filme && !v.muted) v.muted = true; });
  v.addEventListener("click", function () { if (filme) return; if (v.paused) v.play(); else v.pause(); });
  dlg.querySelector(".player-fechar").addEventListener("click", fecha);
  dlg.querySelector(".player-ant").addEventListener("click", function () { i = (i - 1 + fila.length) % fila.length; toca(); });
  dlg.querySelector(".player-prox").addEventListener("click", function () { i = (i + 1) % fila.length; toca(); });
  dlg.addEventListener("click", function (e) { if (e.target === dlg || e.target.classList.contains("player-palco")) fecha(); });
  dlg.addEventListener("close", function () { v.pause(); });
  document.addEventListener("click", function (e) {
    var c = e.target.closest && e.target.closest(".an .v-capa");
    if (c) { abre(lista, +c.dataset.i, false); return; }
    var j = e.target.closest && e.target.closest(".an [data-filme]");
    if (j) abre([j.dataset.filme], 0, true);
  });
})();
